import React from "react";
import '../App.css';
import DynamicIsland from "../components/DynamicIsland";
import CurrentTime from "../components/CurrentTime";
import Back from "../components/Back";

function StudentEvent(){
    return (
        <div className="container">
            <CurrentTime/>
            <DynamicIsland/>
            <Back/>
        </div>
    );
}

export default StudentEvent;